<template>
    <div>
        <transition name="fade" appear>
            <div v-if="!loading && !capRunning" class="page welcome-page">
                <section :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <v-container>
                        <v-row style="direction: ltr;">
                            <v-col :cols="pcOnly ? 5 : 12">
                                <div class="youtube-video" style="border-radius: 14px; overflow: hidden;line-height: 0;">
                                    <iframe width="100%" height="300" src="https://www.youtube.com/embed/jMqDFwY1Jas?modestbranding=1&showinfo=0" title="Skill Zone" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </div>
                            </v-col>
                            <v-col :cols="pcOnly ? 7 : 12" :class="{'py-6': phoneOnly, 'py-6 pe-15': pcOnly}">
                                <h1 class="strong-text--text">Who Are We ?</h1>
                                <p class="description mb-0 muted--text mt-5">
                                    <strong class="primary--text">SkillZone</strong> is a leading provider of soft skills training and marketing
                                    Consultancy, we are committed to make people more competent
                                    in business through effective training programs, our strength mainly
                                    comes from extensive experience and Powerful knowledge.
                                </p>
                                <div class="actions mt-12">
                                    <v-btn large depressed outlined color="primary" class="font-weight-bold" :to="{name: 'courses'}" :block="phoneOnly">
                                        <v-icon class="ms-2">mdi-play-box-multiple</v-icon>
                                        <span>Our Courses</span>
                                    </v-btn>
                                    <v-btn large depressed color="primary" class="font-weight-bold me-md-3 mt-3 mt-md-0" :to="{name: 'register'}" :block="phoneOnly">
                                        <v-icon class="ms-2">mdi-account-plus</v-icon>
                                        <span>Join Us Now</span>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </section>
                <section :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <v-container :class="{'px-0': phoneOnly}" class="text-center">

                        <div class="d-flex flex-column flex-lg-row">
                            <div>
                                <v-avatar size="150">
                                    <v-img src="/img/skillzone-instructor.png"></v-img>
                                </v-avatar>
                                <div class="mt-2">
                                    <div>Trainer</div>
                                    <div class="font-weight-bold mb-2">Dr.Sherif Elsawah</div>
                                    <div class="details-text muted--text">Certified trainer</div>
                                </div>
                            </div>
                            <div class="mt-6 mt-md-0 ms-md-12 ltr-dir text-left flex-grow-1">
                                <h1 v-if="pcOnly" class="strong-text--text mb-8">Biography</h1>
                                <ul style="line-height: 1.6;" class="mx-6 ma-md-0">
                                    <li>Pharmacist</li>
                                    <li>15 years experience in pharmaceutical sales management.</li>
                                    <li>District sales manager " ADWIA pharmaceutical" for 4 years.</li>
                                    <li>Senior District Manager Biomed Pharma 1 year</li>
                                    <li>District sales manager Ducray "Pierre Fabre " multinational company in KSA (Saudi Arabia) for 5 years.</li>
                                    <li>Line sales manager" Bioxell pharma Egypt " for 1 year & half.</li>
                                    <li>Founder of "Skillzone " training Academy.</li>
                                </ul>
                            </div>
                        </div>
                    </v-container>
                </section>
                <section v-if="featuredCourses && featuredCourses.length" :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <v-container :class="{'px-0': phoneOnly}">
                        <div class="d-md-flex justify-space-between align-center mb-8 mb-lg-15 ltr-dir">
                            <h1 class="strong-text--text">
                                <v-icon :size="pcOnly ? 45 : 36" color="strong-text">mdi-play-box-multiple-outline</v-icon>
                                Courses
                            </h1>
                            <template v-if="pcOnly">
                                <div class="flex-grow-1 mx-12">
                                    <v-divider></v-divider>
                                </div>
                                <div>
                                    <v-btn outlined color="primary" :to="{name: 'courses'}">
                                        <span>All Courses</span>
                                        <v-icon left>mdi-arrow-right</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </div>
                        <div v-if="pcOnly">
                            <v-row>
                                <v-col cols="12" md="6" lg="3" v-for="(course, i) in featuredCourses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                    <course-card short :course="course"> </course-card>
                                </v-col>
                            </v-row>
                        </div>
                        <v-list v-else two-line class="px-0">
                            <course-list-item v-for="(course, i) in featuredCourses" class="px-7 px-lg-4" :key="course.id + '-' + i" :course="course" />

                            <div class="my-4 mx-6">
                                <v-btn block outlined color="primary" :to="{name: 'courses'}">
                                    <span>الانتقال إلى الدورات</span>
                                    <v-icon right>mdi-arrow-left</v-icon>
                                </v-btn>
                            </div>
                        </v-list>
                    </v-container>
                </section>

                <slot name="footer" />
            </div>
        </transition>


        <app-welcome-dialog v-if="platform == 'ios'" v-model="appWelcomeDialog" />
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import AppWelcomeDialog from '@/components/default/dialogs/app-welcome'
import ESection from '@/components/default/layouts/e-section'

import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Welcome",
    data(){
        return {
            loading: false,
        }
    },
    components: {
        ESection,
        CourseCard,
        CourseListItem,
        AppWelcomeDialog
    },
    computed: {
        ...GlobalComputed,
        welcomeData(){
            return this.$store.state.globalModule.welcomeData;
        },
        featuredCourses(){
            return this.welcomeData.featured_courses;
        }
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                this.$store.dispatch('loadWelcomeData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    // this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    created(){
        if (this.capRunning){
            if (this.platform === 'ios'){
                this.appWelcomeDialog = true;
            }else{
                this.$router.push({name: 'login'});
            }
        }else{
            if (!this.featuredCourses || this.featuredCourses.length === 0){
                this.loadData();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.youtube-video{
    iframe{
        @media(max-width: 960px){
            height: 220px!important;
        }
    }
}
section{
    h1{
        font-size: 2.4rem!important;
        line-height: 1.3;
        font-weight: 500;

        @media(max-width: 960px){
            font-size: 1.9rem!important;
            text-align: center;
        }
    }
    ul{
        li{
            margin-bottom: 10px;
        }
    }
}
</style>